import { CSSProperties } from "react";

import { Segmented, SegmentedProps } from "antd";
import classNames from "classnames";

export enum SegmentedVariant {
  /** Global EVA "pill" look (default). */
  Default = "default",
  /** ~antd base look with minor EVA tweaks. */
  Base = "base"
}

const VARIANT_CLASS: Record<SegmentedVariant, string> = {
  [SegmentedVariant.Default]: "",
  [SegmentedVariant.Base]: "eva-segmented-base"
};

interface SegmentedToggleProps extends Omit<SegmentedProps, "ref"> {
  variant?: SegmentedVariant;
  /**
   * Overrides the toggle height (px when a number). Drives item height via
   * calc() in CSS. Falls back per variant: 22px (default), 32px (base).
   */
  height?: number | string;
}

export default function SegmentedToggle({
  variant = SegmentedVariant.Default,
  height,
  className,
  style,
  ...props
}: SegmentedToggleProps) {
  const mergedStyle =
    height == null
      ? style
      : ({
          ...style,
          "--eva-segmented-height": typeof height === "number" ? `${height}px` : height
        } as CSSProperties);

  return (
    <Segmented
      {...props}
      className={classNames(VARIANT_CLASS[variant], className)}
      style={mergedStyle}
    />
  );
}
